<template>
  <div v-if="dataPermohonan.status >= 14">
    <h4 class="section-title">
      Dokumen Hasil
    </h4>
    <hr>
        
    <!-- list dokumen hasil -->
    <div
      class="row"
      v-if="hasilPermohonan"
    >
      <div
        class="col-sm-3 mb-5"
        v-for="h in hasilPermohonan"
        :key="h.id_hasil_permohonan"
      >
        <div
          class="card-item card mb-1"
          style="cursor:pointer"
          :title="'Klik untuk melihat dokumen '"
          @click="lihatDokumen(h)"
        >
          <div class="card-body p-0">
            <div
              class="card-item-bg-img text-center"
              :style="{ backgroundImage: 'url(/uploads/icon-form/)' }"
              style="background: #444"
            >
              <img
                :src="require('./../../assets/img/icon/pdf.png')"
                width="50"
                class="mt-5"
              >
            </div>
            <div
              class="p-3"
              style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis"
            >
              <b>{{ h.jenis_dokumen }}</b>
            </div>
          </div>
        </div>

        <div
          class="text-center"
          v-if="dataPermohonan.status === 14 && namaRole != 'Penduduk'"
        >
          <button
            type="button"
            class="btn btn-primary m-1"
            title="Edit dokumen hasil"
            @click="editDokumenHasil(h)"
          >
            <i class="fa fa-pencil-alt" />
          </button>
          <button
            type="button"
            class="btn btn-danger m-1"
            title="Hapus dokumen hasil"
            @click="hapusDokumenHasil(h)"
          >
            <i class="fa fa-trash" />
          </button>
        </div>
      </div>
      <div
        class="col-12 text-center my-3"
        v-if="
          namaRole === 'Penduduk' ||
            namaRole === 'Operator Desa' ||
            namaRole === 'Kepala Desa'
        "
      >
        <p v-if="hasilPermohonan.length === 0">
          Dokumen hasil belum ada
        </p>
      </div>
      <div
        class="col-sm-3"
        v-if="namaRole === 'Operator Dukcapil' || namaRole === 'Operator Dukcapil Kecamatan'"
      >
        <div
          v-if="dataPermohonan.status === 14 && widgetJenisDokumenHasil.length > 0"
          class="card-item card"
          style="cursor:pointer"
          :title="'Upload Dokumen Hasil'"
          @click="tambahDokumenHasil"
        >
          <div class="card-body p-0">
            <div style="height:202px;padding-top:52px;width:100%;text-align:center">
              <i
                class="fa fa-plus mb-3"
                style="font-size: 2rem;color: rgba(0,0,0,.2);"
              /><br>
              <b>Upload Dokumen Hasil</b>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- pernyataan dokumen hasil siap -->
    <div v-if="namaRole === 'Operator Dukcapil' || namaRole === 'Operator Dukcapil Kecamatan'">
      <div v-if="dataPermohonan.status === 14">
        <hr>
        <div class="form-group row">
          <label
            for=""
            class="col-form-label col-md-3 text-md-right text-left"
          >Dokumen Hasil</label>
          <div class="col-md-9">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="konfirmasiDokHasilSiap"
                v-model="konfirmasiDokHasilSiap"
              >
              <label
                class="custom-control-label"
                for="konfirmasiDokHasilSiap"
              >Saya {{ ($store.getters.getUserProfile) ? $store.getters.getUserProfile.nama_lengkap : '' }} menyatakan dokumen hasil sudah siap</label>
            </div>


            <button
              :disabled="!konfirmasiDokHasilSiap"
              class="btn btn-primary mt-3"
              @click="setDokumenHasilSiap($event)"
            >
              <i class="fa fa-check mr-2" />Dokumen Hasil Sudah Siap
            </button>
                        
            <div class="alert alert-primary alert-has-icon mt-3">
              <div class="alert-icon">
                <i class="far fa-lightbulb" />
              </div>
              <div class="alert-body">
                <div class="alert-title">
                  Informasi
                </div>
                Jika seluruh dokumen hasil sudah diupload, klik "Dokumen Hasil Sudah Siap" untuk memberi notifikasi kepada pemohon
                bahwa dokumen hasil sudah siap.
              </div>
            </div>
                        
            <div
              class="alert alert-warning alert-has-icon mt-3"
              v-if="konfirmasiDokHasilSiap"
            >
              <div class="alert-icon">
                <i class="fas fa-info-circle" />
              </div>
              <div class="alert-body">
                <div class="alert-title">
                  Perhatian
                </div>
                Aksi ini bersifat final dan tidak dapat diubah demi keamanan dan integritas data.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- modal -->
        
    <b-modal
      id="modal-upload-dokumen-hasil"
      title="Upload Dokumen"
    >
      <div
        class="form-group"
        v-if="formDokHasilAksi === 1"
      >
        <label for="">Jenis Dokumen</label>
        <select
          class="form-control"
          v-model="formDokHasil.jenis_dokumen"
          v-if="selectedPaket"
        >
          <!-- <option v-for="f in selectedPaket.output_dok" :key="f" :value="f">{{f}}</option> -->
          <option
            v-for="f in widgetJenisDokumenHasil"
            :key="f"
            :value="f"
          >
            {{ f }}
          </option>
        </select>
      </div>
      <div
        class="form-group"
        v-if="formDokHasilAksi === 2"
      >
        <label for="">Jenis Dokumen</label>
        <input
          type="text"
          class="form-control"
          v-model="formDokHasil.jenis_dokumen"
          disabled
        >
      </div>

      <div class="form-group">
        <input
          type="file"
          class="form-control"
          @change="selectFile"
          accept="application/pdf"
        >
        <small>File .pdf, maksimal {{ maxFileSize }} MB</small>
        <div
          class="progress mt-3"
          v-if="loading"
        >
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            :aria-valuenow="uploadProgress"
            aria-valuemin="0"
            aria-valuemax="100"
            :style="{width: uploadProgress+'%'}"
          />
        </div>
      </div>

      <template #modal-footer>
        <button
          id="btnSubmitUploadDokumen"
          type="button"
          class="btn btn-primary"
          @click="submitUploadDokumen($event)"
        >
          <i class="fa fa-check mr-2" />Upload
        </button>
      </template>
    </b-modal>

    <b-modal
      id="modal-lihat-dokumen-hasil"
      title="Dokumen Hasil"
      size="lg"
    >
      <div
        class="embed-responsive"
        style="height: 70vh"
      >
        <iframe
          id="iframepdf"
          :src="linkDokumenHasilShow"
          class="embed-responsive-item"
        />
      </div>
      <template #modal-footer>
        <button
          type="button"
          value=""
          class="btn btn-primary"
          @click="cetakDokumenHasil"
        >
          <i class="fa fa-print mr-2" />Cetak
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  data() {
    return {
      formDokHasil: {
        jenis_dokumen: null,
        file: null
      },
      formDokHasilShow: '',
      formDokHasilAksi: 1, // 1=tambah, 2=edit
      widgetJenisDokumenHasil: [],
      konfirmasiDokHasilSiap: false, // checkbox untuk enable tombol berkas siap
      loading: false, // loading upload file
      uploadProgress: 0,
      linkDokumenHasilShow: '',
      maxFileSize: 2
    }
  },
  computed: {
    dataPermohonan() {
      return this.$store.getters.getDataPermohonan
    },
    hasilPermohonan() {
      return this.$store.getters.getHasilPermohonan
    },
    selectedPaket() {
      return this.$store.getters.getSelectedPaket
    },
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    },
  },
  methods: {
    setWidgetDokumenHasil(data) {
      let paket = data.paket_layanan.paket
      paket.output_dok = paket.output_dok.split(',')
      this.widgetJenisDokumenHasil = paket.output_dok

      // beberapa kondisi supaya bisa upload berkas lain
      if (this.dataPermohonan.id_paket_layanan === 16 || this.dataPermohonan.id_paket_layanan === 14) {
        // ada tambahan kartu keluarga lain untuk Penerbitan Kartu Keluarga Baru Karena Pisah KK Dalam 1 Alamat,
        // Penerbitan Kartu Keluarga Baru Karena Membentuk Keluarga Baru
        this.widgetJenisDokumenHasil.push('Kartu Keluarga Lain')
      }

      const paketLayananPindah = [49, 50, 51, 52, 53, 54]
      if (paketLayananPindah.includes(this.dataPermohonan.id_paket_layanan) && data.findIndex(f => f.jenis_dokumen == 'Biodata') === -1) {
        // ada tambahan Biodata untuk permohonan pindah
        this.widgetJenisDokumenHasil.push('Biodata')
      }

      console.log(this.widgetJenisDokumenHasil)
      // supaya tercentang
      if (data.status >= 15) {
        this.konfirmasiDokHasilSiap = true
      }
    },
    updateWidgetDokumenHasil(data) { // data = hasil permohonan
      // jika dokumen sudah diupload, supaya hilang dari list option
      let widget = []
      let widgetDokumenHasil = this.dataPermohonan.paket_layanan.paket.output_dok

      widgetDokumenHasil.forEach(e => {
        if (data.findIndex(f => f.jenis_dokumen == e) === -1) {
          widget.push(e)
        }
      })

      // beberapa kondisi supaya bisa upload berkas lain
      if (this.dataPermohonan.id_paket_layanan === 16 && data.findIndex(f => f.jenis_dokumen == 'Kartu Keluarga Lain') === -1) {
        // ada tambahan kartu keluarga lain untuk Penerbitan Kartu Keluarga Baru Karena Pisah KK Dalam 1 Alamat
        widget.push('Kartu Keluarga Lain')
      }
      if (this.dataPermohonan.id_paket_layanan === 14 && data.findIndex(f => f.jenis_dokumen == 'Kartu Keluarga Lain') === -1) {
        // ada tambahan kartu keluarga lain untuk Penerbitan Kartu Keluarga Baru Karena Membentuk Keluarga Baru
        widget.push('Kartu Keluarga Lain')
      }

      const paketLayananPindah = [49, 50, 51, 52, 53, 54]
      if (paketLayananPindah.includes(this.dataPermohonan.id_paket_layanan) && data.findIndex(f => f.jenis_dokumen == 'Biodata') === -1) {
        // ada tambahan Biodata untuk permohonan pindah
        widget.push('Biodata')
      }


      this.widgetJenisDokumenHasil = widget
    },
    lihatDokumen(e) {
      this.$store.dispatch('getFile', e.file).then(res => {
          let blob = new Blob([res.data], { type: 'application/pdf' })
          this.linkDokumenHasilShow = window.URL.createObjectURL(blob)
      })
      this.$bvModal.show('modal-lihat-dokumen-hasil')
    },
    tambahDokumenHasil() {
      this.formDokHasilAksi = 1
      this.formDokHasilShow = ''
      this.$bvModal.show('modal-upload-dokumen-hasil')
    },
    editDokumenHasil(e) {
      this.formDokHasilShow = e
      this.formDokHasilAksi = 2

      this.formDokHasil.jenis_dokumen = e.jenis_dokumen
      this.$bvModal.show('modal-upload-dokumen-hasil')

    },
    hapusDokumenHasil(e) {
      swal({
        title: "Konfirmasi",
        text: "Yakin ingin menghapus dokumen hasil?",
        icon: "warning",
        buttons: {
          cancel: "Batal",
          ok: {
            text: "Yakin, hapus",
            value: "ok",
          },
        }
      }).then(val => {
        if (val === 'ok') {
          this.$store.dispatch('deleteHasilPermohonanByOperator', e.id_hasil_permohonan).then(res => {
            if (res.data.status) {
              swal({
                title: "Berhasil",
                text: res.data.message,
                icon: "success",
                buttons: "Ok"
              })
              this.$store.dispatch('fetchHasilPermohonanByOperator', this.dataPermohonan.id_data_permohonan).then(res => {
                if (res.data.status) {
                  this.$store.dispatch('setHasilPermohonan', res.data.data)
                }
              })
            } else {
              swal({
                title: "Gagal",
                text: res.data.message,
                icon: "error",
                buttons: "Ok"
              })
            }
          }).catch(err => {
            // console.log(err)
            switch (err.response.status) {
              case 500:
                this.$router.push({ path: '/500' })
                break;

              case 400:
                swal({
                  title: "Gagal",
                  text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                  icon: "error",
                  buttons: "Ok"
                })
                break;

              default:
                swal({
                  title: "Gagal",
                  text: err.response.data.message,
                  icon: "error",
                  buttons: "Ok"
                })
                break;
            }
          })
        } else {

          // button.removeAttribute('disabled')
          // button.innerHTML = buttonHtml
        }
      })
    },
    cetakDokumenHasil(){
      window.open(this.linkDokumenHasilShow)
    },
    setDokumenHasilSiap(e) {
      let button = e.target
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Dokumen Hasil Sudah Siap'

      let formData = new FormData()
      formData.append('status', 15)

      if (this.namaRole === 'Operator Desa') {
        formData.append('is_operator_desa', 1)
      } else if (this.namaRole === 'Operator Dukcapil' || this.namaRole === 'Operator Dukcapil Kecamatan') {
        formData.append('is_operator_dukcapil', 1)
      }

      let idDataPermohonan = this.dataPermohonan.id_data_permohonan

      this.$store.dispatch('updatePermohonanPenduduk', { id: idDataPermohonan, form: formData }).then(res => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: "Dokumen Hasil Permohonan Sudah Siap",
            icon: "success",
            buttons: "Ok"
          })

          this.notify({
            type_notif: 'STATUS_PERMOHONAN',
            type_receiver: 'penduduk',
            id_penduduk: this.dataPermohonan.id_penduduk,
            id_data_permohonan: idDataPermohonan,
            status_permohonan: 15,
            via: 'mail,fcm',
            title_notif: 'Dokumen Kependudukan Sudah Siap. Login ke Aplikasi',
            body_notif: `Dokumen kependudukan dari permohonan ${this.dataPermohonan.paket_layanan.layanan.nama_layanan} yang anda ajukan sudah siap. Silahkan login ke aplikasi.`
          })

          this.$emit('showPermohonan')

        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      }).catch(err => {
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      })
    },
    submitUploadDokumen(e) {
      if (!this.formDokHasil.file) {
        swal({
          title: "Gagal",
          text: "File kosong",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (!this.formDokHasil.jenis_dokumen) {
        swal({
          title: "Gagal",
          text: "Pilih jenis dokumen",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }

      // validasi file
      const maxFileSize = this.maxFileSize * 1048576 // dalam bytes. 1024 * 1024
      if (this.formDokHasil.file.size > maxFileSize) {
        swal({
          title: "Gagal",
          text: `Ukuran file lebih dari ${this.maxFileSize} MB`,
          icon: "error",
          buttons: "Ok"
        })
        this.formDokHasil.file = null
      }

      let button = document.querySelector('#btnSubmitUploadDokumen')
      let buttonHtml = button.innerHTML
      this.loading = true
      this.uploadProgress = 0

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Upload'

      let formData = new FormData()
      formData.append('file', this.formDokHasil.file)
      formData.append('jenis_dokumen', this.formDokHasil.jenis_dokumen)
      formData.append('id_data_permohonan', this.dataPermohonan.id_data_permohonan)

      let dispatch = 'storeHasilPermohonanByOperator'
      let data = formData
      if (this.formDokHasilAksi === 2) {
        dispatch = 'updateHasilPermohonanByOperator'
        data = {
          id: this.formDokHasilShow.id_hasil_permohonan,
          form: formData
        }
      }

      this.$store.dispatch(dispatch, data).then(res => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
          // this.loadFilePermohonan()
          this.$store.dispatch('fetchHasilPermohonanByOperator', this.dataPermohonan.id_data_permohonan).then(res => {
            if (res.data.status) {
              this.$store.dispatch('setHasilPermohonan', res.data.data)
            }
          })
          this.$bvModal.hide('modal-upload-dokumen-hasil')
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml

        this.uploadProgress = 100
        setTimeout(() => {
          this.loading = false
        }, 1000)
      }).catch(err => {
        // console.log(err)
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
        this.uploadProgress = 100
        setTimeout(() => {
          this.loading = false
        }, 1000)
      })
    },
    notify(data) {
      let formData = new FormData
      for (let key in data) {
        formData.append(key, data[key])
      }

      this.$store.dispatch('sendNotifikasi', formData).then(r => {
        // console.log(r)
      })
    },
    selectFile(e) {
      this.formDokHasil.file = e.target.files[0]
    },
  },
  created() {
    if (this.dataPermohonan) {
      if (this.dataPermohonan.paket) {
        this.setWidgetDokumenHasil(this.dataPermohonan)
      }
    }

    if (this.hasilPermohonan) {

      this.updateWidgetDokumenHasil(this.hasilPermohonan)
    }
  },
  watch: {
    dataPermohonan(newVal) {
      this.setWidgetDokumenHasil(newVal)
    },
    hasilPermohonan(newVal) {
      if (this.dataPermohonan.id_data_permohonan) {
        this.updateWidgetDokumenHasil(newVal)
      }

    }
  }
}
</script>